import type { AxiosInstance } from 'axios';
import { PropertyModel } from '@/models/property';
import { Property } from '../types/property';
import { transformProperties } from '../transforms/property';

class PropertyService {
  private client: AxiosInstance;

  constructor(client: AxiosInstance) {
    this.client = client;
  }

  async getAllProperties(): Promise<PropertyModel[]> {
    const response = await this.client.get<Property[]>('/properties', {
      params: {
        'key[$ne]': 'null',
        '$sort[name]': 1,
      },
    });

    return transformProperties(response.data.data);
  }
}

export { PropertyService };
